import { h } from 'vue'

export const EmptyComponent = {
  render: () => h('div', 'Coming Soon...'),
}
